import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-tickets',
  template: require('./tickets.component.html'),
  styles: [require('./tickets.component.css')]
})
export class TicketsComponent implements OnInit {
  urlMarina: SafeResourceUrl = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.getUrlChamados();
  }

  getUrlChamados(): void {
    const email = 'admin'; // Substitua pelo email obtido dinamicamente    
    let dynamicUrl = `http://localhost:55555/${email}/admin`;
    if (window.location.host === 'admin.easymarine.com.br') {
      dynamicUrl = `https://tickets.easymarine.com.br/${email}/admin;`
    }
    if (window.location.host === 'adm.homolog.easymarine.com.br') {
      dynamicUrl = `https://tickets.homolog.easymarine.com.br/${email}/admin;`
    }


    this.urlMarina = this.sanitizer.bypassSecurityTrustResourceUrl(dynamicUrl);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/tickets/tickets.component.ts